import MuiLink from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'

const Link = ({
  children,
  ...props
}) =>
  <MuiLink
    component={RouterLink}
    {...props}
  >
    {children}
  </MuiLink>

export default Link